import React, { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import RichText from "../Richtext/RichText"
import Heading from "../Heading/Heading"
import Image from "../Image/Image"
import styles from "./user-instructions-tw-styles"
import i18nMessages from "../../../constants/messages/pt-BR"
import headingStyles from "../Heading/Heading-tw-styles"
import getWidth from "../../../utils/gridWidth"
import Typography from "../../Generic/Typography"


export default class UserInstructions extends Component {
    componentDidMount() {
        const leftWrapper = document.getElementsByClassName(
            i18nMessages.leftwrapper
        )
        if (
            leftWrapper.length > 0 &&
            leftWrapper[0]?.children[0].innerHTML === ""
        ) {
            leftWrapper[0].style.display = i18nMessages?.none
        }

        const rightWrapper = document.getElementsByClassName(
            i18nMessages?.rightwrapper
        )
        if (rightWrapper[0].children[0].innerHTML === "") {
            rightWrapper[0].style.display = i18nMessages.none
        }
    }

    getHeading = (heading, id, classes) => {
        let headingStyle = ""
        if (
            heading?.styles &&
            headingStyles[heading?.styles.trim()] !== undefined
        ) {
            headingStyle = headingStyles[heading.styles.trim()]
        }
        const widthClass = getWidth(heading.componentWidth)
        return (
            <Typography
                id={id}
                key={heading.sys.id}
                className={classNames(widthClass, headingStyle, classes)}
                component={
                    heading.headingName
                        ? heading.headingName.toLowerCase()
                        : "div"
                }
                >
                {heading.heading && heading.heading}
            </Typography>
        )
    };

    render() {
        const { data } = this.props
        this.imageItem = 0
        return (
            <div className={styles.mainWrapper} tabIndex='-1'>
                {data &&
                    data.section2Collection &&
                    data.section2Collection.items &&
                    data.section2Collection.items.length > 0 && (
                    <div className={styles.leftWrapper}>
                        <div className={styles.slideTextSection} tabIndex='-1'>
                            {data &&
                                    data.section1Collection &&
                                    data.section1Collection.items.map(
                                        (item, index) => {
                                            switch (item.__typename) {
                                            case i18nMessages.HeadingTypes:
                                                return this.getHeading(
                                                    item,
                                                    "slideText" + index,
                                                    "slideText" + index
                                                )
                                            default:
                                                return null;
                                            }
                                        }
                                    )}
                        </div>

                        <div
                            id={i18nMessages.slideSection}
                            className={styles.slideImageSection}
                            tabIndex='-1'
                        >
                            {data &&
                                    data.section2Collection &&
                                    data.section2Collection.items.map(
                                        (item, index) => {
                                            switch (item.__typename) {
                                            case i18nMessages.Image:
                                                this.imageItem++
                                                return (
                                                    <div
                                                        id={
                                                            "slideImage" +
                                                                index
                                                        }
                                                        className={
                                                            styles.slideAfterImg
                                                        }
                                                        key={index}
                                                        tabIndex='-1'
                                                    >
                                                        <Image
                                                            image={item}
                                                            styles={
                                                                "before-after-image-styles"
                                                            }
                                                        />
                                                    </div>
                                                )
                                            default:
                                                return null;
                                            }
                                        }
                                    )}
                        </div>
                    </div>
                )}
                <div className={styles.rightWrapper}>
                    <div className={styles.howtoUse}>
                        {data &&
                            data.section3Collection &&
                            data.section3Collection.items.map((item) => {
                                switch (item.__typename) {
                                case i18nMessages?.ContentTypeRichText:
                                    return (
                                        <RichText
                                            richtext={item}
                                            styles={"how-to-use-richtext"}
                                        />
                                    )
                                case i18nMessages?.HeadingTypes:
                                    return (
                                        <Heading
                                            heading={item}
                                            styles={
                                                "before-after-heading-style"
                                            }
                                        />
                                    )
                                default:
                                    return null;
                                }
                            })}
                    </div>
                </div>
            </div>
        )
    }
}

UserInstructions.propTypes = {
    data: PropTypes.oneOfType([PropTypes.object]).isRequired,
}
